import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    Input,
    OnInit,
    ViewChild
} from '@angular/core';
import {SelectFieldOptionsService} from '../../services/select-field-options-service.service';
import {DynFillableTextField} from "../../domain/meta/fields/dyn-fillable-text-field";
import {DynField} from "../../domain/meta/dyn-field";
import {AbstractControl, FormControl, Validators} from "@angular/forms";

@Component({
    selector: 'app-fillable-text',
    templateUrl: './fillable-text.component.html',
    styleUrls: ['./fillable-text.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FillableTextComponent implements OnInit {

    @Input() field: DynField;
    @Input() control?: AbstractControl;

    dynamicText: string[] = [];

    @ViewChild('editableField') editableField: ElementRef;
    split = "<@SPLIT>"
    defaultText = "campo a completar";
    controls: FormControl[];
    fillableTextField: DynFillableTextField;
    editingMode: boolean;
    constructor(private cd: ChangeDetectorRef) {
    }


    ngOnInit() {
        this.editingMode = this.control != null;
        //console.log('editingmode ', this.editingMode)
        this.fillableTextField = this.field as DynFillableTextField;
        let textSplitted = this.field.getText().split('{@}');
        const text = textSplitted.join('||[replace-me]||').split('<br>').join('||<br>||')
            .split('<br/>').join('||<br>||');
        this.dynamicText = text.split('||');
        if(this.editingMode){
            this.controls = [];
            this.dynamicText.forEach(field => {
                if(field === '[replace-me]'){
                    const control = new FormControl(this.defaultText, Validators.required);
                    control.valueChanges.subscribe(() => this.updateControlValue());
                    this.controls.push(control)
                } else {
                    this.controls.push(null);
                }
            });

        }

        this.cd.markForCheck();

    }

    updateControlValue() {
        let inputs = [];
        let valid = true;
        this.controls.filter(x => x != null).forEach(c => {
            //arregla un bug que le pone doble salto de linea:
            if(c.value.endsWith("<br>")) c.setValue(c.value.substring(0, c.value.length-4));
            inputs.push(c.value);
            if(c.value === this.defaultText || c.value === ''){
                valid = false;
            }
        });
        //console.log('VALUE ', inputs.join(this.split))
        this.control.setValue(inputs.join(this.split));
        if(!valid){
            this.control.setErrors({error: true});
        }
    }


}



// WEBPACK FOOTER //
// ./src/app/forms/components/form-data-fillable-text/fillable-text.component.ts